<template>

  <div v-show="showWelcome && !show_activebtnPage && !show_noconnection" id="welcomePage" class="welcomePage-modal">
    <!-- {{"webView : " + isApp + " / " + "mobile : " + isMobile + " / " + device}} -->

    <div class="sc-header">

      <div class="sc-header--title"> {{ projectTitleName }} 腦力健身房
        <!-- <el-dropdown style="display:none;">
          <span class="el-dropdown-link">
            <img class="header-info" src="./assets/iconInfo.png" alt="" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="showOnboarding_">你可以做些什麼?</el-dropdown-item>
            <el-dropdown-item>意見回饋</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>

      <div class="sc-header--minify-button" @click="onClose('')">
        <div></div>
      </div>

    </div>
    <div v-if="!legalNotice" class="welcome-modal-content">
      <div class="welcome-bg" :style="{ backgroundImage: `url(${welcomBg})` }"></div>

      <div class="welcome-pic">
        <img :src=titleImageUrl alt="">
      </div>

      <div class="welcome-text" @click="welcomePage_checkMobile">
        <div class="title">
          <p>{{ welcome_title }}</p>
          <p></p>
        </div>
        <!-- <div>
              <p>{{ appGpsLater }}</p>
            </div> -->
        <div class="subtitle">
          <p>{{ welcome_subtitle }}</p>
          <p></p>
        </div>
        <div class="description">
          <p>{{ welcome_content }}</p>
          <p></p>
        </div>
      </div>
      <div class="welcome-stsrt-btn" style="cursor: pointer;" @click="handleStartClick">
        <div class="welcome-stsrt-btn-content">
          <p>開始吧</p>
        </div>
      </div>
      <div v-if="firebaseLoading" class="full-white-page">
        <div style="transform: translateY(-45px);">
          <div class="full-white-page-loader">
          </div>
          <div class="full-white-page-loader-text">
            Loading...
          </div>
        </div>
      </div>
    </div>
    <div v-else class="welcome-modal-content" style="margin: 0 auto;text-align: center;">
      <iframe ref="iframeRef" src="/static/legal_notice.html" width="100%" height="98%" frameborder="0"
        style="text-align: center;" @load="onIframeLoad"></iframe>
        <div class="legal-button-wrap" :class="{ 'active-button-wrap': activeButton }">
          <button class="legal-button" :disabled="!activeButton" :class="{ 'active-button': activeButton }" @click="closeWelcome()">同意，並開始使用</button>
        </div>
    </div>
  </div>
</template>

<script>
import { uuid } from 'vue-uuid'
import { EventBus } from '../../bus.js'
import { mapGetters } from 'vuex'
import { checkFirebase, checkFirebaseTokenVerify } from '@/pages/js/firebaseHelper.js'
// import firebase from 'firebase/app'
// import "firebase/auth"
// import firebaseConfigs from '@/pages/js/firebaseConfigs.js'
export default {
  components: {
  },
  props: {
    welcome_title: {
      type: String,
      default: () => ''
    },
    welcome_subtitle: {
      type: String,
      default: () => ''
    },
    welcome_content: {
      type: String,
      default: () => ''
    },
    immediacy_time: {
      type: Number,
      default: () => ''
    },
    projectTitleName: {
      type: String,
      default: () => ''
    },
    showWelcome: {
      type: Boolean,
      default: () => false
    },
    show_activebtnPage: {
      type: Boolean,
      default: () => false
    },
    show_noconnection: {
      type: Boolean,
      default: () => false
    },
    titleImageUrl: {
      type: String,
      default: ''
    },
    welcomBg: {
      type: String,
      default: ''
    },
    onClose: {
      type: Function,
      required: true
    },
    onMinify: {
      type: Function,
      required: true
    },
    handle_logoutTimer: {
      type: Function,
      required: true
    },
    handle_show_noconnection: {
      type: Function,
      required: true
    },
    isApp: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    device: {
      type: String,
      default: ''
    },
    latData: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    ...mapGetters([
      'appLoc',
      'udnCookie'
    ])
  },
  methods: {
    onIframeLoad() {
      const iframe = this.$refs.iframeRef;
      if (!iframe) return;

      try {
        const iframeWindow = iframe.contentWindow;
        const iframeDocument = iframeWindow.document;
        const iframeBody = iframeDocument.body;

      
        const hasScroll = iframeDocument.documentElement.scrollHeight > iframeBody.clientHeight;
        if (!hasScroll) {
          // 如果沒有滾動條，直接啟用按鈕
          this.activeButton = true;
          return;
        }

        // 監聽 iframe 滾動事件
        iframeWindow.addEventListener("scroll", () => {
          const scrollTop = iframeWindow.scrollY || iframeDocument.documentElement.scrollTop;
          const clientHeight = iframeBody.clientHeight;
          const scrollHeight = iframeDocument.documentElement.scrollHeight;

          if (scrollTop + clientHeight >= scrollHeight - 20) {
            this.activeButton = true
          }
        });
      } catch (error) {
        console.error("無法存取 iframe 內容，可能是跨域問題", error);
      }
    },
    pushClickAibotStartEvent() {
      const gtm = require('@/plugins/gtm/datalayer').default();
      gtm.methodsToBeExposed.push_click_aibot_start();
      console.log('已推送 push_click_aibot_start 事件');
    },
    handleStartClick() {
      this.pushClickAibotStartEvent(); // 推送 GTM 事件
      this.legalNotice = true; // 切換到法律聲明畫面
    },
    pushClickAibotAgreeEvent() {
      const gtm = require('@/plugins/gtm/datalayer').default();
      gtm.methodsToBeExposed.push_click_aibot_agree();
      console.log('已推送 push_click_aibot_agree 事件');
    },
    closeWelcome() {
      this.pushClickAibotAgreeEvent()
      this.legalNotice = false
      this.welcomePageCloseModal()
    },
    showOnboarding_() {

      this.$emit("showOnboarding", "")
    },
    async welcomePageCloseModal() {
      this.$socketManager.init()
      sessionStorage.setItem('client_id', uuid.v1())
      if (this.$store.getters.cToken) {
        this.firebaseLoading = true
        const idToken = await checkFirebase(this.$route.params.projectId, this.$store.getters.cToken)
        sessionStorage.removeItem('conversation_id')
        this.$store.commit('SET_FIREBASE_TOKEN', idToken)
        this.firebaseLoginSuccess()
      }
      else if (this.$store.getters.firebaseToken) {
        this.firebaseLoginSuccess()
      } else {
        this.firebaseLoading = true
        try {
          const idToken = await checkFirebase(this.$route.params.projectId)
          this.$store.commit('SET_FIREBASE_TOKEN', idToken)
          this.firebaseLoginSuccess()
        } catch (error) {
          console.log(error)
          this.$store.commit('SET_FIREBASE_TOKEN', null)
          this.firebaseLoginFailed()
        }
      }
    },
    firebaseLoginFailed() {
      this.firebaseLoading = false
      this.handle_show_noconnection(true, 'firebase')
    },
    firebaseLoginSuccess() {
      this.$emit('handle_show-welcome')
      this.handle_logoutTimer(this.immediacy_time, true)
      EventBus.$emit('openWeather')
      this.firebaseLoading = false
    },

    welcomePage_checkMobile() {
      // alert("webView : " + this.isApp + " / " + "mobile : " + this.isMobile + " / " + this.device)
    }
  },
  data() {
    return {
      // immediacy_time: 0
      // appGPS: {},
      appGpsLater: {},
      moneyUdnCookie: [],
      legalNotice: false,
      firebaseLoading: false,
      activeButton: false
    }
  },
  mounted() {
    // this.appGPS = localStorage.getItem('GPSLocationData')
    setTimeout(
      () => {
        this.appGpsLater = localStorage.getItem('GPSLocationData')
      }, 100)
    // EventBus.$on('receiveCookie',({moneyUdnCookie})=>{
    //   this.moneyUdnCookie = moneyUdnCookie
    // })
    // console.log(`localStorage + timeout:${this.appGpsLater}`);
  },
}
</script>
<style scoped>
@import "./styles/welcome.css";

.full-white-page {
  position: absolute;
  left: 0px;
  top: 0px;
  height: 100%;
  width: 100%;
  background-color: rgb(255, 255, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.full-white-page-loader {
  border: 10px solid #BFBFBF;
  /* Light grey */
  border-top: 10px solid #848484;
  /* Blue */
  border-radius: 50%;
  width: 90px;
  height: 90px;
  animation: spin 2s linear infinite;
  text-align: center;
}

.full-white-page-loader-text {
  position: fixed;
  top: 45px;
  left: 45px;
  transform: translate(-25%, 25%);
  font-size: 12px;
  color: #505050;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.iframeCookie {
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lotData {
  font-weight: bold;
}

.legal-button-wrap {
  position: sticky;
  left: 0;
  width: 100%;
  height: 100px;
  text-align: center;
  margin: 20px auto;
  bottom: 24px;
  border: 0px solid #BFBFBF;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 45%, rgb(255, 255, 255) 100%);
}

@media screen and (max-device-width: 450px){
  .legal-button-wrap {
    bottom: 0px;
  }
}

.legal-button {
  position: relative;
  width: 334px;
  height: 40px;
  text-align: center;
  border-radius: 20px;
  margin-top:36px;
  border: 0px solid #BFBFBF;
  color: white;
  font-size: 16px;
  font-weight: 700;
  background-color: #D3D7D9;
}

.active-button {
  background-color: #E56A7F;
  color: white;
}

.active-button-wrap {
  /* background: rgba(255, 255, 255, 0); */
}
</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/Welcome.vue